<template>
  <section class="admin-content">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ─────────────────────────────────────── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-navigation" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Out of State (Corridor) Manager</h4>
              <small style="opacity: .8;">
                {{ codes && codes.total ? codes.total : 0 }} corridor request(s)
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Filter Form (restricted) ───────────────────────── -->
        <div
          v-if="user && (user.user_role == 1 || user.job_title == 'Claims Vetter' || user.job_title == 'Claims Verifier' || user.type == 'shis')"
          class="card shadow form-card mb-4"
        >
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-filter" style="font-size:12px;"></i></div>
            <h6 class="mb-0 font-weight-bold text-white">Filter Corridor Requests</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <form @submit.prevent="getCodesAgency">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Select SHIA</label>
                  <select class="form-control" v-model="query.agency">
                    <option :value="state" v-for="state in states" :key="state.id">
                      {{ state.agency_name }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Select Status</label>
                  <v-select v-model="query.status" :options="statuses" />
                </div>
                <div class="form-group col-md-5">
                  <label class="small font-weight-bold text-secondary">
                    <i class="fe fe-calendar mr-1"></i> Start Date
                  </label>
                  <input type="date" class="form-control" v-model="query.from" />
                </div>
                <div class="form-group col-md-5">
                  <label class="small font-weight-bold text-secondary">
                    <i class="fe fe-calendar mr-1"></i> End Date
                  </label>
                  <input type="date" class="form-control" v-model="query.to" />
                </div>
                <div class="form-group col-md-2">
                  <label class="small font-weight-bold text-secondary">Rows</label>
                  <select class="form-control" v-model="query.paginate_value">
                    <option>30</option>
                    <option>100</option>
                    <option>500</option>
                    <option>1000</option>
                    <option>2000</option>
                  </select>
                </div>
              </div>
              <div class="d-flex" style="gap: 8px;">
                <button type="submit" class="btn btn-submit px-4">
                  <i class="fe fe-filter mr-1"></i> Filter
                </button>
                <button type="button" class="btn btn-outline-secondary px-4">
                  <download-excel
                    :data="codes.data"
                    :fields="json_fields"
                    type="xls"
                    :escapeCsv="false"
                    :name="'Corridor_data' + '.xls'"
                  >
                    <i class="fe fe-download mr-1"></i> Export Excel
                  </download-excel>
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- ── Corridors Table ────────────────────────────────── -->
        <div class="card shadow table-card">
          <div class="px-4 pt-4 pb-3">
            <h6 class="mb-0 font-weight-bold text-dark">
              <i class="fe fe-navigation text-primary mr-2"></i>
              {{ codes && codes.total ? codes.total : 0 }} Out of State Requests
            </h6>
          </div>
          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th px-4">Date Requested</th>
                  <th class="table-th">Enrollee SHIA</th>
                  <th class="table-th">Secondary Provider</th>
                  <th class="table-th">Enrollee</th>
                  <th class="table-th">Status</th>
                  <th class="table-th" v-if="user && (user.type == 'shis' || user.type == 'employee')">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="diag in codes.data" v-bind:key="diag.id" class="table-row">
                  <td class="px-4 py-3">
                    <p class="mb-0 font-weight-bold" style="font-size:.88rem;">{{ diag.date_requested }}</p>
                    <small class="text-primary">{{ diag.created_at | moment("from", "now") }}</small>
                  </td>
                  <td class="py-3" style="font-size:.88rem;">
                    <span v-if="diag.agency">{{ diag.agency.agency_name }}</span>
                  </td>
                  <td class="py-3" style="font-size:.88rem;">
                    <span v-if="diag.recipientfacility">{{ diag.recipientfacility.agency_name }}</span>
                  </td>
                  <td class="py-3" style="font-size:.88rem;">
                    <span v-if="diag.enrollee">{{ diag.enrollee.full_name }}</span>
                  </td>
                  <td class="py-3">
                    <span :class="`btn m-b-15 badge badge-soft-${diag.color}`">{{ diag.status }}</span>
                  </td>
                  <td class="py-3">
                    <button
                      class="btn btn-sm btn-outline-primary"
                      data-toggle="modal"
                      @click="getCode(diag)"
                      data-target="#slideRightModalAll"
                    >
                      <i class="fe fe-eye mr-1"></i> View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="px-4 py-3 d-flex justify-content-center">
            <b-pagination
              v-model="currentPage"
              :total-rows="codes.total"
              :per-page="codes.per_page"
              aria-controls="my-table"
              @input="getCodes(currentPage ? currentPage : 1)"
            ></b-pagination>
          </div>
        </div>

      </div>

      <!-- ── Corridor Detail Modal ───────────────────────────── -->
      <div
        class="modal fade modal-slide-right"
        id="slideRightModalAll"
        tabindex="-1"
        role="dialog"
        aria-labelledby="slideRightModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content" id="printDiv" ref="printNow" v-if="auth_code">
            <!-- Header -->
            <div class="modal-header bg-soft-info" style="border-bottom: 2px solid #e3eaf0;">
              <div class="d-flex align-items-center w-100 justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="avatar avatar-sm mr-3">
                    <div class="avatar-title rounded-circle bg-info text-white">
                      <i class="fe fe-navigation"></i>
                    </div>
                  </div>
                  <div>
                    <p class="mb-0 font-weight-bold text-dark" id="slideRightModalLabel">Out of Station Request</p>
                    <span :class="`badge badge-soft-${auth_code.color} mt-1`" style="font-size: 0.75rem; text-transform: capitalize;">
                      <i class="fe fe-activity mr-1"></i>{{ auth_code.status }}
                    </span>
                  </div>
                </div>
                <button type="button" class="close ml-0" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>

            <!-- Body -->
            <div class="modal-body px-3 py-3">

              <!-- Update Provider toggle -->
              <button
                v-if="auth_code.status != 'approved'"
                :class="`btn btn-block mb-3 ${showProviderUpdate ? 'btn-info' : 'btn-outline-info'}`"
                @click="toggleProviderUpdate(auth_code)"
              >
                <i :class="`fe ${showProviderUpdate ? 'fe-x-circle' : 'fe-edit-2'} mr-1`"></i>
                {{ showProviderUpdate ? "Cancel Update" : "Update Provider" }}
              </button>

              <!-- Provider dropdown -->
              <div
                v-if="showProviderUpdate && auth_code.status != 'approved'"
                class="card border-info mb-3"
                style="border-radius: 8px;"
              >
                <div class="card-body p-3">
                  <p class="font-weight-bold text-info mb-2">
                    <i class="fe fe-home mr-1"></i> Select New Provider
                  </p>
                  <div class="form-group mb-2">
                    <v-select
                      v-model="selectedProvider"
                      :options="providerOptions"
                      label="agency_name"
                      placeholder="Search provider..."
                    />
                  </div>
                  <button
                    class="btn btn-success btn-block"
                    :disabled="!selectedProvider || isUpdatingProvider"
                    @click="submitProviderUpdate(auth_code)"
                  >
                    <i class="fe fe-save mr-1"></i>
                    {{ isUpdatingProvider ? "Saving..." : "Save Provider" }}
                  </button>
                </div>
              </div>

              <!-- Info rows -->
              <div class="card mb-3" style="border-radius: 8px; overflow: hidden;">
                <div class="card-header py-2 bg-light">
                  <span class="font-weight-bold text-dark" style="font-size: 0.85rem;">
                    <i class="fe fe-file-text mr-1 text-success"></i> Request Details
                  </span>
                </div>
                <div class="list-group list-group-flush">

                  <div class="list-group-item px-3 py-2 d-flex align-items-start">
                    <i class="fe fe-hash text-muted mr-3 mt-1" style="min-width:16px;"></i>
                    <div>
                      <p class="mb-0 text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.04em;">Approval Code</p>
                      <p class="mb-0 font-weight-bold text-dark">{{ auth_code.code_created || '—' }}</p>
                    </div>
                  </div>

                  <div class="list-group-item px-3 py-2 d-flex align-items-start">
                    <i class="fe fe-user text-muted mr-3 mt-1" style="min-width:16px;"></i>
                    <div>
                      <p class="mb-0 text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.04em;">Enrollee</p>
                      <p class="mb-0 font-weight-bold text-dark">{{ auth_code.enrollee.full_name }}</p>
                      <p class="mb-0 text-secondary" style="font-size:0.8rem;">{{ auth_code.enrollee.id_card_number }}</p>
                    </div>
                  </div>

                  <div class="list-group-item px-3 py-2 d-flex align-items-start">
                    <i class="fe fe-layers text-muted mr-3 mt-1" style="min-width:16px;"></i>
                    <div>
                      <p class="mb-0 text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.04em;">Enrollee Plan</p>
                      <p class="mb-0 font-weight-bold text-dark">{{ auth_code.enrollee.sector || '—' }}</p>
                    </div>
                  </div>

                  <div class="list-group-item px-3 py-2 d-flex align-items-start">
                    <i class="fe fe-map-pin text-muted mr-3 mt-1" style="min-width:16px;"></i>
                    <div>
                      <p class="mb-0 text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.04em;">Enrollee SHIA</p>
                      <p class="mb-0 font-weight-bold text-dark">
                        <span v-if="auth_code.agency != null">{{ auth_code.agency.agency_name }}</span>
                        <span v-else>—</span>
                      </p>
                    </div>
                  </div>

                  <div class="list-group-item px-3 py-2 d-flex align-items-start">
                    <i class="fe fe-arrow-right-circle text-muted mr-3 mt-1" style="min-width:16px;"></i>
                    <div>
                      <p class="mb-0 text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.04em;">Secondary SHIA</p>
                      <p class="mb-0 font-weight-bold text-dark">{{ auth_code.secondaryagency.agency_name }}</p>
                    </div>
                  </div>

                  <div class="list-group-item px-3 py-2 d-flex align-items-start">
                    <i class="fe fe-home text-muted mr-3 mt-1" style="min-width:16px;"></i>
                    <div>
                      <p class="mb-0 text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.04em;">Out of Station Facility</p>
                      <p class="mb-0 font-weight-bold text-dark">{{ auth_code.recipientfacility.agency_name }}</p>
                    </div>
                  </div>

                  <div class="list-group-item px-3 py-2 d-flex align-items-start">
                    <i class="fe fe-calendar text-muted mr-3 mt-1" style="min-width:16px;"></i>
                    <div>
                      <p class="mb-0 text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.04em;">Date Requested</p>
                      <p class="mb-0 font-weight-bold text-dark">{{ auth_code.created_at | moment("ddd, MMM Do YYYY") }}</p>
                      <p class="mb-0 text-secondary" style="font-size:0.8rem;">{{ auth_code.created_at | moment("h:mm a") }}</p>
                    </div>
                  </div>

                </div>
              </div>

              <!-- Notes -->
              <div v-if="auth_code.comments && auth_code.comments.length">
                <p class="font-weight-bold text-dark mb-2" style="font-size:0.85rem;">
                  <i class="fe fe-message-circle text-primary mr-1"></i> Notes
                </p>
                <div
                  class="media mb-2 p-2"
                  style="background:#f8f9fa; border-left: 3px solid #5b8dee; border-radius: 4px;"
                  v-for="comment in auth_code.comments"
                  v-bind:key="comment.id"
                >
                  <div class="avatar avatar-sm mr-2">
                    <div class="avatar-title rounded-circle bg-soft-primary text-primary" style="font-size:0.75rem;">
                      <i class="fe fe-user"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <p class="mb-0" style="font-size:0.875rem;">{{ comment.body }}</p>
                    <small class="text-muted">
                      <span v-if="comment.user">{{ comment.user.full_name }} &middot; </span>
                      {{ comment.created_at | moment("MMM Do YYYY, h:mm a") }}
                    </small>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="text-muted text-center small mt-2">
                  <i class="fe fe-message-circle mr-1"></i> No notes yet
                </p>
              </div>

            </div>

            <!-- Footer actions -->
            <div class="modal-footer" style="border-top: 2px solid #e3eaf0;">
              <div class="row w-100 mx-0">
                <div class="col-6 pl-0 pr-1">
                  <button
                    v-if="
                      auth_code.status != 'primary_approval' &&
                      user.institutional_id == auth_code.enrollee.agency_id
                    "
                    class="btn btn-success btn-block"
                    @click="
                      updateStatus(
                        auth_code,
                        'primary_approval',
                        `Approved by ${user.agency.agency_name} SHIA`
                      )
                    "
                  >
                    <i class="fe fe-check-circle mr-1"></i> Primary Approval
                  </button>

                  <button
                    v-if="
                      auth_code.status != 'approved' &&
                      user.type == 'employee' &&
                      user.institutional_id != auth_code.enrollee.agency_id
                    "
                    class="btn btn-success btn-block"
                    @click="generateCode(auth_code, `Final Approval by ${user.agency.agency_name}`)"
                  >
                    <i class="fe fe-check-circle mr-1"></i> Final Approval
                  </button>
                </div>

                <div class="col-6 pr-0 pl-1">
                  <button
                    v-if="
                      user.institutional_id ==
                        auth_code.enrollee.agency_id &&
                      auth_code.status != 'primary_approval' &&
                      auth_code.status != 'rejected'
                    "
                    class="btn btn-danger btn-block"
                    @click="
                      updateStatus(
                        auth_code,
                        'rejected',
                        `Declined by ${user.agency.agency_name}`
                      )
                    "
                  >
                    <i class="fe fe-x-circle mr-1"></i> Primary Decline
                  </button>

                  <button
                    v-if="
                      user.institutional_id !=
                        auth_code.enrollee.agency_id &&
                      auth_code.status != 'approved' &&
                      auth_code.status != 'rejected'
                    "
                    class="btn btn-danger btn-block"
                    @click="
                      updateStatus(
                        auth_code,
                        'rejected',
                        `Declined by ${user.agency.agency_name}`
                      )
                    "
                  >
                    <i class="fe fe-x-circle mr-1"></i> Final Decline
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="spinner" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import { chatContextMixin } from "@/chat/pageContext";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
let agency = JSON.parse(localStorage.getItem("agency"));

export default {
  components: {
    Navbar,
    Loading,
  },
  mixins: [chatContextMixin],
  data() {
    return {
      agency: agency,
      isLoading: false,
      fullPage: true,
      user: null,
      showadder: false,
      userDetails: false,
      statuses: ["pending", "primary_approval", "approved", "rejected"],
       states: [],
      json_fields: {
        "Date Requested": "created_at",
        "Auth Code": "code_created",
        "Code Usage": "code_usage",
        "Primary Diagnosis": "encounter.diagnosis.name",
        "Enrollee SHIA Number": "enrollee.id_card_number",
        "Intra Referral": "intra_referral",
        "Secondary Facility": "recipientfacility.agency_name",
      },
      auth_code: null,
      showProviderUpdate: false,
      providerOptions: [],
      selectedProvider: "",
      isUpdatingProvider: false,
      query: {
        agency: "",
        provider_id: "",
        status: "",
        from: "",
        to: "",
        paginate_value: "",
      },
      codes: "",

      rows: "1",
      perPage: 15,
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
     this.axios
        .get(`/api/v1/auth/agencies`)
        .then((response) => {
          this.states = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });

  },
  methods: {
    getCode(corridor) {
      this.isLoading = true;
      this.setChatContext("authorization_code", corridor.id, "#slideRightModalAll");
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/single_authorization_code/${corridor.id}`)
        .then((response) => {
          this.auth_code = response.data;
          this.showProviderUpdate = false;
          this.providerOptions = [];
          this.selectedProvider = "";

          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    getCodes(currentPage) {
      this.getCodesAgency(currentPage);
    },

    getCodesAgency(currentPage) {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/authorization_code/${agency.id}`, {
          params: {
            is_corridor: 1,
            page: currentPage,
            primary_agency_id: this.query.agency.agency_id,
            secondary_agency_id: agency.id,
            status: this.query.status,
            paginate_value: this.query.paginate_value,
            from: this.query.from,
            to: this.query.to,
          },
        })
        .then((response) => {
          this.codes = response.data;
          this.isLoading = false;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },

    generateCode(auth_code, comment) {
      if (confirm("Are you sure you want to Approve?")) {
        this.axios
          .post(`/api/v1/auth/generateCode`, {
            id: auth_code.id,
            expiry_days: 2,
          })
          .then((response) => {
            this.addComment(auth_code, comment);
            console.log(response);
            this.$toasted.info("Generated Successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    updateStatus(auth_code, status, comment) {
      if (confirm("Are you sure you want to reject this request?")) {
        this.axios
          .post(`/api/v1/auth/updateCodeRequestStatus`, {
            id: auth_code.id,
            status: status,
          })
          .then((response) => {
            console.log(response);
            this.show = true;
            this.addComment(auth_code, comment);

            this.$toasted.info(`${status} Successfully!`, {
              position: "top-center",
              duration: 3000,
            });
          });
      }
    },

    getSecondaryAgencyId(auth_code) {
      return (
        auth_code.secondary_agency_id ||
        (auth_code.secondaryagency && auth_code.secondaryagency.id) ||
        ""
      );
    },

    toggleProviderUpdate(auth_code) {
      this.showProviderUpdate = !this.showProviderUpdate;

      if (this.showProviderUpdate) {
        this.loadProvidersForAuthCode(auth_code);
      }
    },

    loadProvidersForAuthCode(auth_code) {
      const secondaryAgencyId = this.getSecondaryAgencyId(auth_code);

      if (!secondaryAgencyId) {
        this.$toasted.error("Secondary SHIA not available", {
          position: "top-center",
          duration: 3000,
        });
        this.showProviderUpdate = false;
        return;
      }

      this.axios
        .get(`/api/v1/auth/providerAgency/${secondaryAgencyId}`)
        .then((response) => {
          this.providerOptions = response.data.data || [];

          if (auth_code.recipientfacility && auth_code.recipientfacility.id) {
            const currentProvider = this.providerOptions.find(
              (provider) => provider.id == auth_code.recipientfacility.id
            );
            this.selectedProvider = currentProvider || "";
          }
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Failed to load providers", {
            position: "top-center",
            duration: 3000,
          });
        });
    },

    submitProviderUpdate(auth_code) {
      if (!this.selectedProvider || !this.selectedProvider.id) {
        this.$toasted.error("Select a provider", {
          position: "top-center",
          duration: 3000,
        });
        return;
      }

      this.isUpdatingProvider = true;
      this.axios
        .post(`/api/v1/auth/updateExpiry`, {
          id: auth_code.id,
          expiry_date: auth_code.expiry_date,
          referred_to_facility: this.selectedProvider.id,
        })
        .then((response) => {
          console.log(response);
          this.$toasted.info("Provider updated successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.getCode(auth_code);
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Provider update failed", {
            position: "top-center",
            duration: 3000,
          });
        })
        .finally(() => {
          this.isUpdatingProvider = false;
        });
    },

    addComment(auth_code, comment) {
      this.axios
        .post(`/api/v1/auth/addComment/referral`, {
          authorization_code_id: auth_code.id,
          body: comment,
        })
        .then((response) => {

          console.log(response);
          this.show = false;
          this.getCode(auth_code);
        });
    },
  },
  created() {
    this.getCodes();
  },
};
</script>

<style>
/* Keep the slide-right modal fixed to the full viewport at all scroll positions */
#slideRightModalAll {
  position: fixed !important;
}

#slideRightModalAll .modal-dialog {
  position: fixed !important;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100vh !important;
  margin: 0;
  display: flex;
  flex-direction: column;
}

#slideRightModalAll .modal-content {
  height: 100vh !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

#slideRightModalAll .modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
}

#slideRightModalAll .modal-header,
#slideRightModalAll .modal-footer {
  flex-shrink: 0;
}
</style>
